import { render, staticRenderFns } from "./presentation-file-list-page.html?vue&type=template&id=0bfb87c8&scoped=true&external"
import script from "./presentation-file-list-page.js?vue&type=script&lang=js&external"
export * from "./presentation-file-list-page.js?vue&type=script&lang=js&external"
import style0 from "./presentation-file-list-page.scss?vue&type=style&index=0&id=0bfb87c8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb87c8",
  null
  
)

export default component.exports